import React from 'react';

/** Triggered when Esc key is triggered and when user focuses out of a target component.  */
const useEscFocusOut = (target, handler) => {
  React.useEffect(() => {
    const currentTarget = target && target.current;
    if (!currentTarget) return;
    const onEsc = (e) => {
      if (e.key === 'Escape') {
        currentTarget && handler(e);
      }
    };
    const onFocusIn = (e) => {
      if (!currentTarget.contains(document.activeElement)) {
        handler(e);
      }
    };
    currentTarget.addEventListener('keydown', onEsc);
    document.addEventListener('focusin', onFocusIn);
    // eslint-disable-next-line consistent-return
    return () => {
      currentTarget.removeEventListener('keydown', onEsc);
      document.removeEventListener('focusin', onFocusIn);
    };
  }, [target, handler]);
};

export default useEscFocusOut;
